/**
  * Contact zip auto-fill
 */

 const ajaxzip = () => {

}

export default ajaxzip